import { render, staticRenderFns } from "./OpenBriefcase.vue?vue&type=template&id=5d06b551&scoped=true"
import script from "./OpenBriefcase.vue?vue&type=script&lang=js"
export * from "./OpenBriefcase.vue?vue&type=script&lang=js"
import style0 from "./OpenBriefcase.vue?vue&type=style&index=0&id=5d06b551&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d06b551",
  null
  
)

export default component.exports